<template>
  <section :class="$style.sectionRoot">
    <header :class="$style.sectionHeader">
      {{ displayName }} Import
    </header>
    <div :class="$style.sectionContent">
      <p>
        You may run another import of new {{ displayName }} users to your current JumpCloud user
        base at any point.
      </p>
      <FlatActionButton
        :action="importUsersClicked"
      >
        import users
      </FlatActionButton>
    </div>
  </section>
</template>
<script>
import { DirectoryNameConsts, DirectoryTypeConsts } from 'client/util/Constants';
import DirectoryActionsMixin from 'client/directories/components/DirectoryActionsMixin';
import DirectoryDialogsHelper from 'client/directories/DirectoryDialogsHelper';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';

export default {
  name: 'DirectoryImport',

  components: {
    FlatActionButton,
  },

  mixins: [
    DirectoryActionsMixin,
  ],

  props: {
    gSuiteId: {
      type: String,
      default: '',
    },
    o365Id: {
      type: String,
      default: '',
    },
    parentType: {
      type: String,
      default: '',
    },
  },

  methods: {
    importUsersClicked() {
      if (this.displayName === DirectoryNameConsts[DirectoryTypeConsts.gSuite]) {
        DirectoryDialogsHelper
          .showDirectoryImportUsersModal(DirectoryTypeConsts.gSuite, this.gSuiteId);
      } else if (this.displayName === DirectoryNameConsts[DirectoryTypeConsts.office365]) {
        DirectoryDialogsHelper
          .showDirectoryImportUsersModal(DirectoryTypeConsts.office365, this.o365Id);
      }

      EventHelper.triggerDirectoryImportUsersLinkClicked({ resourceName: this.parentType });
    },
  },
};
</script>
<style module>
@import '../../css/sections.css';
</style>
